import { inject } from '@angular/core'
import { toObservable } from '@angular/core/rxjs-interop'
import { CanActivateFn, Router } from '@angular/router'
import { of } from 'rxjs'
import { catchError, filter, map, take } from 'rxjs/operators'
import { AppSignals, CommonService, DealerService } from '@appShared/services'
import { MasterDataCacheFacade } from '@appShared/services/master-data-cache.facade'
import { SITE_DIRECTORY_ROUTES } from '@appShared/site-directory.routes'
import { isExemptFromRegistration, notifyRegistrationNotRequired } from './sales-school-registration.facade'

/**
 * Sales School Registration route guard.
 *  - needs a signed-in profile
 *  - Europe 1 / International B dealers are told registration is not required and sent to the dashboard
 *  - waits for the colleges cache, which the College field depends on
 * (The facade repeats the division check when the selected dealer changes while the page is open.)
 */
export const salesSchoolRegistrationGuard: CanActivateFn = () => {
   const appSignals = inject(AppSignals)
   const dealerService = inject(DealerService)
   const commonService = inject(CommonService)
   const masterData = inject(MasterDataCacheFacade)
   const router = inject(Router)

   if (!appSignals.currentProfile()) return false

   if (isExemptFromRegistration(dealerService.selectedDealer()?.dealerInfo)) {
      notifyRegistrationNotRequired(commonService)
      return router.createUrlTree([`/${SITE_DIRECTORY_ROUTES.internal.dashboard.uri}`])
   }

   return toObservable(masterData.colleges).pipe(
      filter(colleges => !!colleges),
      take(1),
      map(() => true),
      catchError(() => of(false))
   )
}
